<template>
  <div class="heading border-b border-gray-200">
    <h1 v-if="title" class="title p-3 text-xl font-bold">{{ title }}</h1>

    <div class="steps">
      <ul class="nav nav-tabs stepsTabs flex p-3 gap-3" role="tablist">
        <li
          class="nav-item"
          v-for="(step, index) in steps"
          :key="index"
          :class="{
            'cursor-not-allowed opacity-50': !isUpdate && index < currentStep,
          }"
          @click="updateCurrentStep(index)"
        >
          <button
            style="cursor: default !important;"
            class="nav-link flex items-center gap-2"
            :class="{
              'active': index === currentStep,
              'cursor-not-allowed': !isUpdate && index < currentStep,
              'completed': isCompleted(index)
            }"
          >
            <span class="step-icon flex items-center justify-center w-6 h-6">
              <i :class="step.icon"></i>
            </span>
            <span class="step-title whitespace-nowrap">{{ step.title }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { update } from "lodash";

export default {
  name: "WizardHeader",
  props: {
    title: {
      type: String,
      default: "",
    },
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      default: 0,
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    isCurrentStepValid: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    updateCurrentStep(index) {
      
      // In create mode: prevent going back
      if (!this.isUpdate && index < this.currentStep) return;

      // In create mode: prevent going forward if current step is invalid
      if (
        !this.isUpdate &&
        index > this.currentStep &&
        !this.isCurrentStepValid
      ) 
      
      {
       
        return;
      }

      // Only emit and update if index is valid
      if (index >= 0 && index < this.steps.length) {
        this.$emit("move", index);
      }
    },

    isCompleted(index) {
      if (!this.isUpdate &&  this.currentStep > index){
        return "completed";
      }
      return "";
      },
  },
};
</script>

<style scoped></style>
